export default "__VITE_ASSET__Dxs5E_ds__"